import { Handle, Position } from '@xyflow/react';

import { colors } from '../theme/colors.ts';

const nodeStyles = {
  padding: '10px',
  borderRadius: '5px',
  fontSize: '12px',
  width: '150px',
  textAlign: 'center',
  cursor: 'pointer',
  background: colors.navy,
  border: `2px solid ${colors.navy}`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Node data is dynamic
const DefaultNode = ({ data }: { data: any }) => {
  // Data is now cleaned by recipeConverter, so we can safely access properties
  const displayName = data?.name || data?.label || data?.type || 'Unknown Node';

  return (
    <div style={nodeStyles}>
      <div>{String(displayName)}</div>
      <Handle type="source" position={Position.Right} />
      <Handle type="target" position={Position.Left} />
    </div>
  );
};

export default DefaultNode;
